// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1zE6n","productName":"Table_productName__2V4z4"};